<div class="container my-3 p-3 contactContent General">
  <h3>{{ "Directory.SearchTitle" | translate }}</h3>

  <strong>{{ "Directory.GeneralInquiry" | translate }}</strong>
  <p [innerHTML] = '"Directory.Below2" | translate'></p>
  <hr>
  <br>
  <div class="row">
    <div class="col">
      <div class="General">
        <strong>Misfortune & Calamity</strong>
        <br><a href="mailto:relief@assessor.lacounty.gov">relief&#64;assessor.lacounty.gov</a>
        <br>(213) 974-8658
      </div>
      <br>
      <div class="General">
        <strong>Business Personal Property</strong>
        <br><a routerLink="/contact/assessor/4">Business Contact Form</a>
        <br>(213) 974-8613
      </div>
      <br>
      <div class="General">
        <strong>Disabled Veterans</strong>
        <br><a href="mailto:dvx@assessor.lacounty.gov">dvx&#64;assessor.lacounty.gov</a>
        <br>(213) 974-3399
      </div>
      <br>
      <div class="General">
        <strong>Homeowners' Exemption</strong>
        <br><a href="mailto:assr-hox@assessor.lacounty.gov">assr-hox&#64;assessor.lacounty.gov</a>
        <br>(213) 974-3415
      </div>
      <br>
      <div class="General">
        <strong>Major Exemptions</strong>
        <br><a href="mailto:exempt@assessor.lacounty.gov">exempt&#64;assessor.lacounty.gov</a>
        <br>(213) 974-3481
      </div>
      <br>

      <div class="">
        <strong>Major Real Properties</strong>
        <br><a href="mailto:majorreal@assessor.lacounty.gov">majorreal&#64;assessor.lacounty.gov</a>
        <br>(213) 974-3108
      </div>


    </div>

    <div class="col">
      <div class="">
        <strong>Manufactured Homes</strong>
        <br><a href="mailto:mfdhomes@assessor.lacounty.gov">mfdhomes&#64;assessor.lacounty.gov</a>
        <br>(213) 974-3119
      </div>
      <br>
      <div class="">
        <strong>Mapping Services</strong>
        <br><a href="mailto:gisinfo@assessor.lacounty.gov">gisinfo&#64;assessor.lacounty.gov</a>
        <br>(213) 974-7352
      </div>
      <br>

      <div class="">
        <strong>Marine/ Aircraft/ Airlines</strong>
        <br><a href="mailto:marineair@assessor.lacounty.gov">marineair&#64;assessor.lacounty.gov</a>
        <br>(213) 974-3119
      </div>

      <br>

      <div class="">
        <strong>Ownership Services</strong>
        <br><a href="mailto:oservices@assessor.lacounty.gov">oservices&#64;assessor.lacounty.gov</a>
        <br>
        <div style="margin-left: .6em">
          <strong style="text-indent: .2rem">Prop. 19: </strong> <a routerLink="/contact/assessor/5">Contact Form</a>
          <br><strong style="text-indent: .2rem">Prop. 58/60/90/110:</strong> (213) 893-1239
          <br><strong style="text-indent: .2rem">General or Investigations:</strong> (213) 974-3441
          <br><strong style="text-indent: .2rem">Change of Mailing Address: </strong> <a href="mailto:addresschange@assessor.lacounty.gov">addresschange&#64;assessor.lacounty.gov</a>
        </div>
      </div>

      <!--<br>
      <div class="">
        <strong>Special Investigations</strong>
        <br><a href="mailto:sinvestigation@assessor.lacounty.gov">sinvestigation@assessor.lacounty.gov</a>
        <br>(213) 974-3304
      </div>-->



      <br>
      <div class="">
        <strong>Public Records Request</strong>
        <br><a href="mailto:pio@assessor.lacounty.gov">pio&#64;assessor.lacounty.gov</a>
        <br>(213) 974-3101
      </div>
      <br>
      <div class="">
        <strong>Subpoenas</strong>
        <br><a href="mailto:legalservices@assessor.lacounty.gov">legalservices&#64;assessor.lacounty.gov</a>
        <br>(213) 974-1674
      </div>
    </div>
  </div>

  <!-- <div class="row">



  </div> -->
</div>
